import { UtilsService } from 'app/modules/utils-service';
import { Component, OnInit } from '@angular/core';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { CONSTANTS } from 'app/core/constants';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OpcionSelect, ReportDefinition } from '../models/tipoReporte.mode';
import { ActivatedRoute } from '@angular/router';
import { ReporteParams } from '../models/resportes.model';
import { environment as env } from 'environments/environments';
import { MatSelectModule } from '@angular/material/select';
import { Usuario, Usuarios } from 'app/models/usuarios.model';
import { REPORTES } from '../reportes-data';
import { Subject, takeUntil } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { ReportesService } from '../reportes.service';
import { Plantilla } from '../../documentos-oficiales/models/plantillas.model';

@Component({
    selector: 'form-descargar-reportes',
    templateUrl: 'form-descargar-reportes.component.html',
    imports:[
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,

        MatSelectModule
    ]
})

export class FormDescargarReporteComponent implements OnInit {
    REPORTES = REPORTES;

    seccionColecciones:number
    seccionBienes: number
    tiposColeccion:number[]= [
        CONSTANTS.TIPOLOGIA_ID_COLECCION_PREHISPANICA, 
        CONSTANTS.TIPOLOGIA_ID_COLECCION_BIENES_INMUEBLES, 
        CONSTANTS.TIPOLOGIA_ID_COLECCION_HISPANICA_REPUBLICANA
    ]

    colecciones:Tipologia[]=[]
    departamentos:Tipologia[]=[]
    municipios:Tipologia[]=[]

    tipology_departamentos:number= env.TIPOLOGIA_ID_DEPARTAMENTOS
    listEstadoTarea:Tipologia[]=[]

    tipoReporteSeleccionado: string; // 'gestiones' o 'solicitudes'
    origenList:Tipologia[]=[]
    usuariosList:Tipologia[]=[]

    tipoFormularios:Tipologia[]=[]

    TIPOLOGIA_ESTADO_DOCUMENTOS:number = CONSTANTS.TIPOLOGIA_ID_ESTADOS_DOCUMENTOS_GENERADOS
    estadosDocumentosGenrados: Tipologia[]=[]

    plantillas: Plantilla[]= []
    id_ficha_registro:number= CONSTANTS.TIPOLOGIA_ID_FICHA_DE_REGISTRO

    params: ReporteParams = new ReporteParams();
    reporteSeleccionado: ReportDefinition | null = null;
    reporteSeleccionado1: string | null = null; // para mantener el valor del radio

    private destroy$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        private reportesService:ReportesService,
        private utilsService:UtilsService
    ) { 
       
    }

    ngOnInit() { 
        this.route.paramMap
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
            const seccionUuid = params.get('seccion_uuid');
            this.seccionBienes= seccionUuid ? +seccionUuid:undefined

            // asignar seccion
            if (this.seccionBienes === env.TIPOLOGIA_ID_SECCION_PREHISPANICA) {
                this.seccionColecciones = this.tiposColeccion[0]; 
            } else if (this.seccionBienes === env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES) {
                this.seccionColecciones = this.tiposColeccion[1];
            } else if (this.seccionBienes === env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA) {
                this.seccionColecciones = this.tiposColeccion[2];
            }

            
        });

        this.route.queryParamMap
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
            this.reporteSeleccionado1 = params.get('reporte');
            this.seleccionarReporte(this.reporteSeleccionado1)
                switch (this.reporteSeleccionado1) {
                case 'bienes-culturales':
                    this.getColecciones();
                    this.getDepartamento();
                    break;

                case 'solicitudes':
                    this.getTipologiaEstado();
                    this.getUsuarios();
                    this.getTipologiasForm();
                    break;

                case 'gestiones':
                    this.getTipologiaEstado();
                    this.getOrigenGestion();
                    this.getUsuarios();
                    break;

                case 'documentos-oficiales':
                    this.getPlantillas()
                    this.getUsuarios();
                    this.getEstadoDocumentos()
                    break;

                default:
                    break;
                }
            });
    }

    seleccionarReporte(tipo: string) {
        const selected = this.REPORTES.find(r => r.tipo === tipo);
        if (selected) {
            this.reporteSeleccionado = selected;
            this.reporteSeleccionado1 = tipo;
            this.params = new ReporteParams();
        }
    }



    getColecciones(): void {
        this.reportesService.getTipologias(this.seccionColecciones)
            .then((response: Tipologia[]) => {
            const colecciones = response.map(c => ({ value: c.tipologiaId, label: c.descripcion }))

            this.setFieldOptions('coleccion', colecciones);
            this.params.coleccion = 0;
            });
    }

    getDepartamento() {
        this.reportesService.getTipologias(this.tipology_departamentos).then((response: Tipologia[]) => {
            const departamentos = response.map(d => ({ value: d.tipologiaId, label: d.descripcion }))
            
            this.setFieldOptions('departamento', departamentos);
            this.params.departamento = 0;
        });
    }

    getMunicipios(tipologiaId: number) {
        this.reportesService.getTipologias(tipologiaId).then((response: Tipologia[]) => {
            const municipios =response.map(m => ({ value: m.tipologiaId, label: m.descripcion }))
            
            this.setFieldOptions('municipio', municipios);
            this.params.municipio = 0;
        });
    }


    getOrigenGestion() {
        this.reportesService.getTipologias(env.TIPOLOGIA_PADRE_ID_ORIGEN_TAREA).then((response: Tipologia[]) => {
            const origenes = response.map(t => ({
            value: t.tipologiaId,
            label: t.descripcion
            }));

            this.setFieldOptions('origen', origenes);
            this.params.origen = 0;
        });
    }

    getUsuarios() {
        let params = { seccion: this.seccionBienes }
        this.reportesService.getUsuarios(params).then((usuarios: Usuarios) => {
            const uaurios = usuarios.data
            .map((usuario: Usuario) => ({
                value: usuario.usuarioId,
                label: usuario.nombreCompleto
            }));

            this.setFieldOptions('usuario', uaurios);
            this.params.usuario = 0;
        });
    }

    getTipologiasForm() {
        this.reportesService.getTipologiasFormularios(env.TIPOLOGIA_CLASIFICACION_FORMULARIOS)
            .then((response: TipologiasInterface[]) => {
            const formularios = response[0].tipologias.map(t => ({
                value: t.valor2,
                label: t.valor2
            }));

            this.setFieldOptions('TipoDocumento', formularios);
            this.params.TipoDocumento = 0 ;
            });
    }



    onSelectChange(campo: string, valor: number) {
        if (campo === 'departamento') {
            this.getMunicipios(valor);
        }
    }


    getTipologiaEstado() {
        const estadoTarea = this.reporteSeleccionado1 === 'solicitudes'
            ? env.TIPOLOGIA_PADRE_ID_ESTADO_SOLICITUD
            : env.TIPOLOGIA_PADRE_ID_ESTADO_GESTIONES;

        this.reportesService.getTipologias(estadoTarea)
            .then((response: Tipologia[]) => {
            const estados = response.map(t => ({
                value: t.tipologiaId,
                label: t.descripcion
            })) || [];

            this.setFieldOptions('estado', estados);
            this.params.estado = 0;
            });
        }

    getEstadoDocumentos(){
        this.reportesService.getTipologias(this.TIPOLOGIA_ESTADO_DOCUMENTOS)
        .then((response: Tipologia[]) => {
            const estados = response.map(t => ({
                value: t.tipologiaId,
                label: t.descripcion
            })) || [];

            this.setFieldOptions('estado', estados);
            this.params.estado = 0;
            });
    }

    getPlantillas(){
        this.reportesService.getPlantillas(this.seccionBienes)
        .then((response: Plantilla[])=>{
            const plantillas = response.map(p =>({
                value: p.plantillaId,
                label: p.nombreDocumento
            })) || [];

            plantillas.unshift({
                value: this.id_ficha_registro,
                label: 'Ficha de registro'
            });

            this.setFieldOptions('TipoDocumento', plantillas);
            this.params.TipoDocumento = 0;
            
        })
    }


    setFieldOptions(fieldName: string, options: OpcionSelect[]) {
        const reporte = this.REPORTES.find(r => r.tipo === this.reporteSeleccionado1);
        const field = reporte?.fields.find(f => f.name === fieldName);
        if (field) {
            field.options = [{ value: 0, label: 'Todos' }, ...options];
        }
    }

    generarReporte(): void {
        const url = this.reporteSeleccionado.endpoint;
        this.params.seccion= this.seccionBienes
        try {
            const payload = this.reportesService.construirInstanciaReporte(this.reporteSeleccionado.tipo, this.params);

            this.utilsService.exportFile(
                url,
                payload,
                'xlsx',
                this.params.nombreReporte
            );
        } catch (error) {
            console.error('Error al generar el reporte:', error);
        }
    }


    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    
}